export default __webpack_public_path__ + "static/media/Calibre-Regular.5953fa35.ttf";